
export function getInvalidSpecialsForOrderType(currentOrder, allSpecials) {
  try {
    if (!currentOrder || !(Number(currentOrder.specialDiscount) > 0)) return [];
    if (!Array.isArray(allSpecials) || allSpecials.length === 0) return [];

    const { orderType } = currentOrder;
    const appliedSpecials = Array.isArray(currentOrder.specials)
      ? currentOrder.specials
      : [];
    return appliedSpecials.filter((applied) => {
      const specialDoc = allSpecials.find((s) => s._id === applied?._id);
      return (
        Array.isArray(specialDoc?.orderTypeKeys) &&
        !specialDoc.orderTypeKeys.includes(orderType)
      );
    });
  } catch (e) {
    return [];
  }
}
